const AnnouncementBar = () => {
  const text = [
    "COD Available Across India",
    "Dermatologically Tested",
    "Korean Inspired",
    "Made for Indian Skin",
    "New Launches Available",
  ];

  return (
    <div className="bg-primary text-white h-9 flex items-center overflow-hidden">
      <div className="marquee">
        <div className="marquee-content">
          {[...text, ...text].map((item, index) => (
            <span key={index} className="marquee-item">
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;